import { render, staticRenderFns } from "./user-wizard-dialog.vue?vue&type=template&id=60bdec27&scoped=true"
import script from "./user-wizard-dialog.vue?vue&type=script&lang=js"
export * from "./user-wizard-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60bdec27",
  null
  
)

export default component.exports